'use client';

import type React from 'react';

// @google/genai FIX: Updated component to accept and spread all SVG props (like x, y, width, height) to the underlying SVG element.
const CapricornIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Capricorn</title>
    <path
      d="M3.5 4L4.26943 4.25648C4.74987 4.4162 5.18643 4.68643 5.54454 5.04454C6.15631 5.65631 6.5 6.48605 6.5 7.35123V7.5M6.5 14.5V7.5M6.5 7.5L8.11826 5.47717C8.37124 5.16095 8.6715 4.88567 9.00845 4.66104C9.65499 4.23001 10.4147 4 11.1917 4H11.6883C12.221 4 12.7486 4.12429 13.226 4.36302L13.4839 4.49194C14.1345 4.81724 14.6292 5.38768 14.8593 6.07776C14.9525 6.35742 15 6.65029 15 6.94508V13.169C15 13.3893 15.0182 13.6092 15.0544 13.8265L15.2972 15.283C15.3531 15.6183 15.4527 15.9426 15.5922 16.2483M15.5922 16.2483L16.3154 15.2538C16.4383 15.0849 16.5742 14.9258 16.7219 14.7781L17.2531 14.2469C17.7313 13.7687 18.3799 13.5 19.0562 13.5H19.0845C19.9627 13.5 20.7764 13.9607 21.2283 14.7138C21.7033 15.5055 21.7033 16.4945 21.2283 17.2862C20.7764 18.0393 19.9627 18.5 19.0845 18.5H18.7675C17.9559 18.5 17.1776 18.1776 16.6038 17.6038L16.3724 17.3724C16.0454 17.0454 15.7819 16.6641 15.5922 16.2483ZM15.5922 16.2483L12.8341 20.0406C12.6146 20.3424 12.3257 20.5871 11.9919 20.7541C11.6684 20.9158 11.3117 21 10.95 21H9"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default CapricornIcon;
